import { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';

export const useGruposConfig = (initialCookies = null) => {
  const [cookiesInstance] = useState(() => new Cookies(initialCookies));
  const [gruposConfig, setGruposConfig] = useState(new Map());

  useEffect(() => {
    const gruposCookie = cookiesInstance.get('grupos');
    if (gruposCookie) {
      try {
        const parsed = new Map(Array.isArray(gruposCookie) ? gruposCookie : []);
        setGruposConfig(parsed);
      } catch (e) {
        console.error('Error parsing grupos cookie', e);
      }
    }
  }, [cookiesInstance]);

  const updateGrupos = (newGroups) => {
    const serializable = Array.from(newGroups);
    cookiesInstance.set('grupos', serializable, {
      path: '/',
      sameSite: 'strict',
      secure: process.env.NODE_ENV === 'production',
      maxAge: 63072000, // 2 años
    });
    setGruposConfig(newGroups);
  };

  const cleanGrupos = () => {
    cookiesInstance.remove('grupos', { path: '/' });
    setGruposConfig(new Map());
  };

  const countGrupos = () => gruposConfig.size;

  const getGruposSeleccionados = () => gruposConfig;

  return {
    getGruposSeleccionados,
    updateGrupos,
    cleanGrupos,
    countGrupos,
  };
};
